import { createFileRoute } from "@tanstack/react-router";
import { CrieSeuSiteGratisContent } from "@/components/pages/CrieSeuSiteGratisContent";
import { pageHead, type LangCode } from "@/i18n/config";
import { CRIE_SEU_SITE_GRATIS_DICTS } from "@/i18n/pages/crie-seu-site-de-graca";

export function crieSeuSiteGratisHead(code: LangCode) {
  const t = CRIE_SEU_SITE_GRATIS_DICTS[code] ?? CRIE_SEU_SITE_GRATIS_DICTS.en;
  const serviceLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: t.jsonLd.name,
    description: t.jsonLd.description,
    provider: { "@type": "LocalBusiness", name: "VB3 Desenvolvimento de Sites", url: "https://vb3.com.br", telephone: "+554591391239" },
    areaServed: { "@type": "Country", name: "Brasil" },
    serviceType: t.jsonLd.serviceType,
    offers: { "@type": "Offer", name: t.jsonLd.name, price: "0", priceCurrency: "BRL", description: t.priceNote, url: "https://vb3.com.br/crie-seu-site-de-graca" },
  };
  const faqLd = { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: t.faqs.map((faq) => ({ "@type": "Question", name: faq.question, acceptedAnswer: { "@type": "Answer", text: faq.answer } })) };
  return pageHead({ code, path: "/crie-seu-site-de-graca", title: t.meta.title, description: t.meta.description, imageAlt: t.meta.imageAlt, jsonLd: [serviceLd, faqLd] });
}

export const Route = createFileRoute("/crie-seu-site-de-graca")({
  head: () => crieSeuSiteGratisHead("pt"),
  component: () => <CrieSeuSiteGratisContent code="pt" />,
});
